import ApiService from './ApiService';

class FavoriteApi extends ApiService {
    constructor() {
        super('favorite');
    }

    addFavorite(payload: { publicationId: number | string }) {
        return this.post('', payload);
    }

    removeFavorite(publicationId: number | string) {
        return this.delete(`${publicationId}`);
    }
}

const favoriteApi = new FavoriteApi();
export default favoriteApi;
